import React, { useCallback, useState } from 'react';
import style from './index.module.css';
import { withHttp } from '@/utils/url';
import { useTheme, useImagePreview, useUrl } from '@/hooks';
import cx from 'clsx';
import { LinkParsedContent } from '@/components';
import { IconHiMessageImagePlaceholder, IconHiMessageImagePlaceholderDark } from '@/assets/hi';
import { omitRefCode } from '@/components/ReferralCodeBtn/utils';

export const CommonPreviewer = (props: {
  value: string | null;
  translatedContent?: string | null;
  handleElementAction: (action: 'click_image' | 'click_url') => void;
  image?: string;
  url?: string;
  creatorId?: string;
}) => {
  const { value, url, image, handleElementAction, translatedContent, creatorId } = props;
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(!!image);
  const { handlePreview } = useImagePreview();
  const { checkAndOpenUrl } = useUrl();
  const emitUrlClickAction = useCallback(() => {
    handleElementAction('click_url');
  }, [handleElementAction]);

  const clickUrlHandler = useCallback(
    (url?: string) => {
      if (url) {
        checkAndOpenUrl(omitRefCode(withHttp(url)), emitUrlClickAction);
      }
    },
    [checkAndOpenUrl, emitUrlClickAction],
  );

  const clickMessageUrl = useCallback(() => {
    clickUrlHandler(url);
  }, [url, clickUrlHandler]);

  return (
    <div className={style.commonPreviewer}>
      <LinkParsedContent
        content={value || ''}
        openUrlCallback={clickUrlHandler}
        translatedContent={translatedContent}
        creatorId={creatorId}
      />
      {url ? (
        <div className={style.linkContainer}>
          <div className={style.link} onClick={clickMessageUrl}>
            {url}
          </div>
        </div>
      ) : null}
      {image ? (
        <div className={style.imageContainer} contentEditable={false}>
          {imageError || imageLoading ? <FailedPlaceholder /> : null}
          <img
            src={image}
            alt=""
            className={cx(style.image, (imageLoading || imageError) && style.invisible)}
            onClick={handlePreview}
            onLoad={() => setImageLoading(false)}
            onError={() => setImageError(true)}
          />
        </div>
      ) : null}
    </div>
  );
};

export const FailedPlaceholder = () => {
  const { isDark } = useTheme();
  const placeholder = isDark ? IconHiMessageImagePlaceholderDark : IconHiMessageImagePlaceholder;
  return (
    <div className={style.imagePlaceholder}>
      <img src={placeholder} alt="img" />
    </div>
  );
};
